import React from 'react';
import { ESellerStore as Platform } from '../../Types';
import ConnectAmazonAccount from '../Onboarding/accounts/ConnectAmazonAccount';
import ConnectShopifyAccount from '../Onboarding/accounts/ConnectShopifyAccount';
import ConnectOtherPlatformAccount from '../Onboarding/accounts/ConnectOtherPlatformAccount';

export default function Store({ business, goForward, amzAccounts, lines }) {
  const isAmazonSeller = business.sellerStore === Platform.amazon;
  const isShopifySeller = business.sellerStore === Platform.shopify;

  function renderStore() {
    if (isAmazonSeller) {
      return (
        <ConnectAmazonAccount
          amzAccounts={amzAccounts}
          lines={lines}
          goForward={goForward}
          business={business}
        />
      );
    } else if (isShopifySeller) {
      return <ConnectShopifyAccount goForward={goForward} />;
    } else {
      return <ConnectOtherPlatformAccount goForward={goForward} />;
    }
  }

  return renderStore();
}
